var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { PanelContext } from '../../context';
import { ELEMENT_TYPES } from '../../helpers/ElementTypes';
import { selectCorrectMedia } from '../../helpers/selectCorrectMedia';
import { PanelMediaContainer, PanelMediaContentContainer, PanelMediaLinkWrapper } from './styles';
const LinkWrapper = (_a) => {
    var { children, dataTest, isVideo = false, onClick } = _a, props = __rest(_a, ["children", "dataTest", "isVideo", "onClick"]);
    const { href } = useContext(PanelContext);
    const useLink = (href || onClick) && !isVideo;
    return useLink ? (_jsx(PanelMediaLinkWrapper, Object.assign({ "data-test": dataTest, href: href, onClick: onClick, onKeyDown: onClick }, props, { children: children }))) : (_jsx(PanelMediaContainer, { "data-test": dataTest, children: children }));
};
const PanelMedia = (_a) => {
    var { image, onClick, videoId, children } = _a, props = __rest(_a, ["image", "onClick", "videoId", "children"]);
    const { dataTest, hideContent, setHasMedia } = useContext(PanelContext);
    useEffect(() => {
        // We keep track in our context whether media is present, because it impacts styling of the parent panel component
        if (hideContent || (!image && !videoId)) {
            setHasMedia(false);
        }
        else {
            setHasMedia(true);
        }
    }, [hideContent, image, setHasMedia, videoId]);
    if (hideContent || (!image && !videoId))
        return null;
    return (_jsxs(_Fragment, { children: [children && _jsx(PanelMediaContentContainer, { children: children }), _jsx(LinkWrapper, Object.assign({ dataTest: `${dataTest}-media`, isVideo: !!videoId, onClick: onClick }, props, { children: (image || videoId) &&
                    selectCorrectMedia({
                        image,
                        videoId,
                    }) }))] }));
};
PanelMedia.PANEL_ELEMENT = ELEMENT_TYPES.MEDIA;
export { PanelMedia };
